import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import { logger } from '@/utils/logger'

import { ApiTaCt040 } from '~/endpoints/ApiTaCt040'

// State types
interface LearningResult {
  balloonMessage: string
}
const getEmptyLearningResult = (): LearningResult => ({
  balloonMessage: '',
})

// State action parameter
interface ActionParamLearningResult {
  processKbn: string
}

@Module({
  stateFactory: true,
  namespaced: true,
  name: 'apis/Result',
})
export default class LearnResult extends VuexModule {
  // States
  private result_ = getEmptyLearningResult()

  // Getters
  get result(): LearningResult {
    return this.result_
  }

  // Mutations
  @Mutation
  updateResult(value: LearningResult) {
    this.result_ = value
  }

  // Actions
  @Action
  clear() {
    this.context.commit('updateResult', getEmptyLearningResult())
  }

  @Action
  async getLearningResult(param: ActionParamLearningResult) {
    logger.trace('in: getLearningResult')
    const api = new ApiTaCt040.Api()

    // API: ApiTaCt040
    const result = await api.get<LearningResult | null>(
      {
        query: {
          processKbn: param.processKbn,
        },
      },
      // success
      (data, _) => {
        return {
          balloonMessage: data.balloonMessage,
        }
      },
      // Error
      (data, status) => {
        logger.error(status, data)
        return null
      }
    )
    if (result === null) {
      return
    }

    this.context.commit('updateResult', result)
  }
}
